import { Radio } from 'antd';
import { connect, FieldComponentProps, FormItem } from 'react-antd-formutil';
import './style.scss';

export interface AuthMethodType {
    title: string;
    desc: string[];
    value: string;
}

interface AuthMethodCardProps {
    onFieldChange?: FieldComponentProps['$onFieldChange'];
    list: AuthMethodType[];
    defaultValue?: string;
}

const AuthMethodCard: React.FC<AuthMethodCardProps> = ({ onFieldChange, list, defaultValue }) => {
    return (
        <FormItem
            className="bankcards-auth-method-card custom-radios"
            name="authMethod"
            label={__('Link account using')}
            required
            $defaultValue={defaultValue}
            validMessage={{
                required: __('Please select method')
            }}
            $onFieldChange={onFieldChange}>
            <Radio.Group>
                {list.map(({ title, value, desc }) => (
                    <Radio key={value} value={value}>
                        <p className="detail-title">{title}</p>
                        {desc.map(item => (
                            <div key={item} className="detail-desc">
                                {item}
                            </div>
                        ))}
                    </Radio>
                ))}
            </Radio.Group>
        </FormItem>
    );
};

export default connect(AuthMethodCard);
